import * as types from "./types";
import { requestAuth } from "../helpers/FetchApi";
import appSettings from "../AppSettings";

export const actionCreators = {
    GetConfigurations: (callback) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Configuration/", { method: "GET" } )
            .then((data) => {
                dispatch({ type: types.GET_CONFIGURATIONS_COMPLETED, payload: data });
                callback();
            })
            .catch( (data) => {
                console.log(data);
            });
    },

    GetTransitions: () => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/Transitions",
            { method: "GET" })
            .then((data) => {
                dispatch({ type: types.GET_TRANSITIONS_COMPLETED, payload: data });
            })
            .catch( (data) => {
                console.log(data);
            });
    }
};


